import {BaseModel} from '@/core/standard/BaseModel';
import { GenericMethod } from '@/core/Types/IRepository';
import {
  ExpenseReportProtocol,
  IExpenseReportModel,
  IExpenseReports,
} from '@/modules/reports/expensesReport/IExpenseReportModel';
import GenericReport from '@/modules/reports/views/GenericReport.vue';
import PaymentsService from '@/modules/requests/requestsTables/PaymentsService';


const ExpenseReport = {
  serial: '',
  importe: 0,
  payed_with: '',
  description: '',
  status: '', 
  user: null,
};

// tslint:disable-next-line:max-line-length
class ExpenseReportModel extends BaseModel<IExpenseReportModel, ExpenseReportProtocol, typeof PaymentsService> {
  public modelName = 'Gastos';

  public request = 'JSON';

  constructor() {
    super(ExpenseReport, PaymentsService);
  }

  // public async getAllExpenseReports (query: GenericReport, toast) {
  //   const response = await this.service.getAllExpenseReports(query);
  //   if (response && response.data) {
  //     return {data: response.data.results, total: response.data.total};
  //   }
  //   return {data: [], total: 0};
  // }

  public async insertExpenseReport(query: GenericReport, toast) {
    const request = await this.service.insertExpenseReport(query);
    if (request.complete) {
      this.handleSuccess(request.data, request.message, toast);
      return true;
    } else {
      this.handleError(request, toast);
      return false;
    }
  }

  public async updateExpenseReport(query: GenericReport, toast) {
    const request = await this.service.updateExpenseReport(query);
    if (request.complete) {
      this.handleSuccess(request.data, request.message, toast);
      return true;
    } else {
      this.handleError(request, toast);
      return false;
    }
  }

  public async deleteExpenseReport(ids: Array<number | string>, toast) {
    const query = {
      query: {pk__in: ids},
      method: 'POST',
      url: 'expenses/delete_all',
    };
    const response = await this.service.request(query as GenericMethod);
    if (response.complete) {
      this.handleSuccess(response.data, response.message, toast);
      return true;
    } else {
      this.handleError(response, toast);
      return false;
    }
  }
}

export default ExpenseReportModel as new() => IExpenseReports;
